import React from 'react'
import { usePutRequest } from '../hooks/request'
import { ANIMAL_TYPE_DETAIL } from '../urls'
import { useMessage } from '../hooks/message'
import AnimalTypeForm from './AnimalTypeForm'

export default function AnimalTypeUpdate({ onCancel, onSuccess, item }) {
    const animalTypeUpdate = usePutRequest({ url: ANIMAL_TYPE_DETAIL.replace('{id}', item.id) })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success } = await animalTypeUpdate.request({ data })

        if (success) {
            showMessage('Успешно изменена', 'is-success')
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Изменить</b>
            </h1>
            <AnimalTypeForm loading={animalTypeUpdate.loading} initialValues={item} onSubmit={onSubmit} onCancel={onCancel} />
        </div>
    )
}
